// 响应式 breakpoint hook（与 AntD 5 默认对齐）
// 用法：const { isMobile, isTablet, isDesktop, current } = useBreakpoint();
import { Grid } from 'antd';
import { isCapacitor } from '../utils/api-base.js';

export type Breakpoint = 'xs' | 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

/**
 * AntD 5 默认断点：
 *   xs: < 480     手机
 *   sm: ≥ 480     大手机
 *   md: ≥ 768     平板竖
 *   lg: ≥ 1024    平板横 / 小桌面
 *   xl: ≥ 1280    桌面
 *   xxl: ≥ 1920   大屏
 *
 * Capacitor 包壳永远当手机：横屏 / fullscreen 锁横屏会让视口宽 > md，否则 layout 切桌面、player 路由失配、闪退竖屏。
 */
export function useBreakpoint() {
	const screens = Grid.useBreakpoint();
	const inCapacitor = isCapacitor();
	const isMobile = inCapacitor ? true : !screens.md;       // < 768
	const isTablet = inCapacitor ? false : (screens.md && !screens.xl);
	const isDesktop = inCapacitor ? false : screens.xl;

	let current: Breakpoint = 'xs';
	if (screens.xxl) current = 'xxl';
	else if (screens.xl) current = 'xl';
	else if (screens.lg) current = 'lg';
	else if (screens.md) current = 'md';
	else if (screens.sm) current = 'sm';

	return { ...screens, isMobile, isTablet, isDesktop, current };
}
